import { IconButton } from '@/components/iconButton';
import { SvgIcon } from '@/components/svgIcon';
import IconCalendar from '@/public/icons/icon-calendar.svg';
import type { MouseEvent, RefObject } from 'react';

export type DatePickerButtonProps = {
  ref?: RefObject<HTMLInputElement | null>;
  parent?: boolean;
};

const findPickerInput = (
  event: MouseEvent<HTMLButtonElement>,
  inputRef: RefObject<HTMLInputElement | null> | undefined,
  parent: boolean
): HTMLInputElement | null => {
  if (inputRef?.current) {
    return inputRef.current;
  }

  const fromField = event.currentTarget.closest('[data-slot="input-row"]')?.querySelector('input');
  if (fromField instanceof HTMLInputElement) {
    return fromField;
  }

  const sibling = parent ? event.currentTarget.parentElement?.previousSibling : event.currentTarget.previousSibling;

  return sibling instanceof HTMLInputElement ? sibling : null;
};

export const handle = (element: ChildNode | HTMLInputElement | null): void => {
  if (!element) {
    console.error('Could not find HTMLInputElement');
    return;
  }
  try {
    (element as HTMLInputElement).showPicker();
  } catch (error) {
    console.error('Could not toggle DatePicker');
  }
};

const DatePickerButton: React.FC<DatePickerButtonProps> = ({ ref, parent = false }) => {
  return (
    <IconButton
      size="small"
      aria-label="Datumspicker öffnen"
      tabIndex={-1}
      onClick={(event) => {
        handle(findPickerInput(event, ref, parent));
      }}
      data-testid="DatePickerButton"
      className="secondary date-picker-button"
    >
      <SvgIcon inheritViewBox={true} component={IconCalendar} />
    </IconButton>
  );
};
export default DatePickerButton;
